/**
 * Sequential takes emit `live-context-invalidated` without `isRunning`.
 * Control already applied cue / play-state via WS; refetching GET_FLOW, sessions,
 * simulation cue sheet, and live-context-state during the take saturates event-service.
 *
 * Refetch the flow graph only when not live (Assets / simulation) or when the event
 * carries an `isRunning` flip (go-live / stop).
 */
export function shouldRefetchQueriesOnLiveContextInvalidated(args: {
  liveIsRunning: boolean;
  isRunningFromEvent?: boolean;
}): boolean {
  if (typeof args.isRunningFromEvent === 'boolean') {
    return true;
  }
  return !args.liveIsRunning;
}
